import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { object } from 'prop-types';

import { useStyles } from '../../styles';
import { useTranslations } from 'components/utilities';
import StarIcon from '@material-ui/icons/Star';

export const MobileCarInfo = ({ car }) => {
	const classes = useStyles();

	const { t } = useTranslations();

	return (
		<Grid container>
			<Grid item xs={12}>
				<Grid container spacing={1} justify="space-between" wrap="nowrap">
					<Grid item xs={6} className={classes.carInfoWrapper}>
						<Box pt={2}>
							<Typography variant="h5" color="primary" component="span">
								{car.discount_price}
							</Typography>{' '}
							<Typography variant="h5" color="primary" component="span">
								{t('common.sarDay')}
							</Typography>
						</Box>

						<Box pt={2}>
							<Typography variant="h5">{car.name}</Typography>

							<Typography variant="h5">{car.year}</Typography>
						</Box>
					</Grid>
					<Grid
						item
						xs={6}
						container
						spacing={1}
						alignItems="center"
						justify="center"
						wrap="nowrap"
						direction="column"
						className={classes.mobileOfficeWrapper}
					>
						<Grid item xs="auto">
							<img
								src={car.office.logo}
								alt={car.office.name}
								className={classes.officeImage}
							/>
						</Grid>
						<Grid item xs="auto">
							<Box
								display="flex"
								alignItems="center"
								gridGap={5}
								flexWrap="noWrap"
							>
								<StarIcon fontSize="small" className={classes.starIcon} />
								<Typography component="span" variant="h6">
									{car.office.rating}
								</Typography>
							</Box>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<img src={car.image} alt={car.name} className={classes.carImg} />
			</Grid>
		</Grid>
	);
};

MobileCarInfo.propTypes = {
	car: object,
};
